import { render, staticRenderFns } from "./MyDataRequest.vue?vue&type=template&id=2d9b9dcc&scoped=true&"
import script from "./MyDataRequest.vue?vue&type=script&lang=js&"
export * from "./MyDataRequest.vue?vue&type=script&lang=js&"
import style0 from "./MyDataRequest.vue?vue&type=style&index=0&id=2d9b9dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9b9dcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9b9dcc')) {
      api.createRecord('2d9b9dcc', component.options)
    } else {
      api.reload('2d9b9dcc', component.options)
    }
    module.hot.accept("./MyDataRequest.vue?vue&type=template&id=2d9b9dcc&scoped=true&", function () {
      api.rerender('2d9b9dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Privacy/MyDataRequest.vue"
export default component.exports